<template>
	<div id="app">
		<div class="app-main">
			<keep-alive>
				<router-view v-if="$route.meta.keepAlive" />
			</keep-alive>
			<router-view v-if="!$route.meta.keepAlive" />
		</div>
		<div class="footer">
			<img src="@/assets/icon/footer.png" />
		</div>

		<el-backtop :bottom="100"></el-backtop>
	</div>
</template>

<script>
export default {
	name: "app",
	data() {
		return {};
	},
	watch: {},
};
</script>
<style>
html,
body,
#app {
	/* height: 100%; */
	margin: 0;
	padding: 0;
}
</style>

<style lang="less">
@import url("~@/assets/css/flex.less");
@import url("~@/assets/css/animate.less");
.footer {
	// margin-top: 30px;
	width: 100%;
	height: 220px;
	overflow: hidden;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
.app-main {
	min-height: calc(100vh - 220px);
}
</style>
